<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card title="Subscribe" code-toggler>

    <p>Please fill in the following steps to subscribe for Chefstein</p>

    <div class="mt-5">
      <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Subscribe to Plan">
        <tab-content title="Subscriber information" class="mb-5" icon="feather icon-user" :before-change="validateStep1">

          <!-- tab 1 content -->
          <form data-vv-scope="step-1">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="First Name" v-model="firstName" class="w-full" name="first_name" v-validate="'required|alpha'" />
              <span class="text-danger">{{ errors.first('step-1.first_name') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="Last Name"  v-model="lastName" class="w-full" name="last_name" v-validate="'required|alpha'" />
              <span class="text-danger">{{ errors.first('step-1.last_name') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input type="email" label="Email"  v-model="email" class="w-full" name="email" v-validate="'required|email'" />
              <span class="text-danger">{{ errors.first('step-1.email') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="Phone number"  v-model="phone" class="w-full" name="phone" v-validate="'required'" />
              <span class="text-danger">{{ errors.first('step-1.phone') }}</span>
            </div>
          </div>
          <vs-divider />
          <div class="vx-row">
            <div class="vx-col w-full mt-5">
              Billing Address Information
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="Street Address" v-model="streetAddress" class="w-full" name="street_address" v-validate="'required'" />
              <span class="text-danger">{{ errors.first('step-1.street_address') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="City" v-model="city" class="w-full" name="city" v-validate="'required|alpha'" />
              <span class="text-danger">{{ errors.first('step-1.city') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="Postal code" v-model="postalCode" class="w-full" name="postal_code" v-validate="'required|numeric'" />
              <span class="text-danger">{{ errors.first('step-1.postal_code') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <label for="country" class="custom-label">Country</label>
              <country-select v-model="country" :country="country" topCountry="FI" class="country-select" name="country" v-validate="'required|alpha'" />
              <span class="text-danger">{{ errors.first('step-1.country') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <label for="region" class="custom-label">Region</label>
              <region-select v-model="region" :country="country" :region="region" class="region-select" name="region" v-validate="'alpha'" />
              <span class="text-danger">{{ errors.first('step-1.region') }}</span>
            </div>
          </div>
          </form>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content title="Payment information" class="mb-5" icon="feather icon-credit-card" :before-change="validateStep2">
          <CardForm ref="cardForm" @card-number-update="cardNumberUpdate" @card-exp-month-update="cardExpMonthUpdate" @card-exp-year-update="cardExpYearUpdate" @card-cvc-update="cardCvcUpdate" />
        </tab-content>

        <!-- tab 3 content -->
        <tab-content title="Choose Plan" class="mb-5" icon="feather icon-briefcase" :before-change="validateStep3">
          <form data-vv-scope="step-3">
            <SubscriptionForm />
            <div class="vx-row">
              <div class="vx-col md:w-4/12 mt-5">
                <label>Discount Code</label>
                <vs-input
                  name="coupon_code"
                  placeholder="Discount Code"
                  v-model="couponCode"
                  class="w-full" />
              </div>
            </div>
          </form>
        </tab-content>
        
      </form-wizard>
    </div>
  </vx-card>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import SubscriptionForm from '../../components/subscription/SubscriptionForm'
import CardForm from '../../components/card/CardForm'

// For custom error message
import { Validator } from 'vee-validate'
import helperMethods from '../../../mixins/helperMethods'
import { 
  getStripeSubscriptions, 
  createCustomerToStripe, 
  createStripeSubscription 
} from '../../../stripe/stripeHelperMethods'

// import firebase from "firebase";
const firebaseActions = require('@/firebase/firebaseActions.js');

const dict = {
  custom: {
    first_name: {
      required: 'First name is required',
      alpha: 'First name may only contain alphabetic characters'
    },
    last_name: {
      required: 'Last name is required',
      alpha: 'Last name may only contain alphabetic characters'
    },
    email: {
      required: 'Email is required',
      email: 'Please enter valid email'
    },
    phone: {
      required: 'Phone number is required',
      numeric: 'Phone number may only contain numbers'
    },
    street_address: {
      required: 'Street address is required',
    },
    postal_code: {
      required: 'Postal code is required',
      numeric: 'Postal code may only contain numbers'
    },
    city: {
      required: 'City is required',
      alpha: 'City may only contain alphabetic characters'
    },
    region: {
      required: 'Region is required',
      alpha: 'Region may only contain alphabetic characters'
    },
    country: {
      required: 'Country is required',
      alpha: 'Country may only contain alphabetic characters'
    },
    card_number: {
      required: 'Card number is required',
      numeric: 'Card number may only contain numbers',
      max: 'Card number may not be greater than 19 characters'
    },
    card_expiration_month: {
      required: 'Card expiration month is required',
      numeric: 'Card expiration month may only contain numbers',
      max: 'Card expiration month may not be greater than 2 characters'
    },
    card_expiration_year: {
      required: 'Card expiration year is required',
      numeric: 'Card expiration year may only contain numbers',
      max: 'Card expiration year may not be greater than 2 characters'
    },
    card_cvc: {
      required: 'Card CVC is required',
      numeric: 'Card CVC may only contain numbers'
    },
    event_name: {
      required: 'Event name is required',
      alpha: 'Event name may only contain alphabetic characters'
    }
  }
}

// register custom messages
Validator.localize('en', dict)

export default {
  components: {
    FormWizard,
    TabContent,
    SubscriptionForm,
    CardForm
  },
  mixins: [
    helperMethods
  ],
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      streetAddress: '',
      postalCode: '',
      city: '',
      region: '',
      country: '',
      cardNumber: '',
      cardExpirationMonth: '',
      cardExpirationYear: '',
      cardCvc: '',
      stripePlans: {},
      stripeProducts: [],
      selectedProduct: '',
      cards: {},
      couponCode: '' // Test env Coupon code: FGcKT8HO
    }
  },
  mounted() {
    this.stripePlans = this.$store.state.AppActiveUser.stripePlans
    this.stripeProducts = this.$store.state.AppActiveUser.stripeProducts
  },
  methods: {
    cardNumberUpdate(val) {
      this.cardNumber = val;
    },
    cardExpMonthUpdate(val) {
      this.cardExpirationMonth = val;
    },
    cardExpYearUpdate(val) {
      this.cardExpirationYear = val;
    },
    cardCvcUpdate(val) {
      this.cardCvc = val;
    },
    validateStep1 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then(result => {
          if (result) {
            
            if (!this.$store.state.AppActiveUser.stripe_id) {
              this.$vs.loading()

              const createCustomerProps = {
                name: this.firstName + ' ' + this.lastName,
                email: this.email,
                phone: this.phone,
                address: {
                  line1: this.streetAddress,
                  city: this.city,
                  postal_code: this.postalCode,
                  state: this.region,
                  country: this.country
                }
              }

              createCustomerToStripe(createCustomerProps)
                .then (async (result) => {
                  //console.log('Create customer POST result:', result);
                  this.$store.commit('UPDATE_USER_INFO', { stripeCustomer: result.data }, { root: true })

                  await firebaseActions.addStripeUserIdToFirestoreCustomer(result.data.id)
                    .then(() => {
                      this.$store.commit('UPDATE_USER_INFO', { stripe_id: result.data.id }, { root: true })
                      resolve(true)
                    }).catch(err => {
                      reject('Error occured while updating Stripe ID to firestore:', err.response.data.raw.message)
                    }).finally(() => {
                      this.$vs.loading.close()
                    })
                }).catch(err => {
                  reject('Error occured while creating Stripe customer: ', err.response.data.raw.message)
                }).finally(() => {
                  this.$vs.loading.close()
                })
            } else {
              // Already in Stripe
              this.$vs.loading.close()
              resolve(true)
            }
          } else {
            reject('correct all values')
          }
        })
      })
    },
    validateStep2 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-2').then(async (result) => {
          if (result) {
            this.$vs.loading()
            const addCardResult = await this.$refs.cardForm.addPaymentCard()
            //console.log('addCardResult', addCardResult)

            if (addCardResult.result === 'resolve') {
              this.$vs.loading.close()
              resolve(addCardResult.payload)
            } 
            else if (addCardResult.result === 'reject') {
              this.$vs.loading.close()
              this.$vs.notify({
                  time: 10000,
                  title: 'Add Payment Card',
                  text: addCardResult.payload,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
              })
              reject(addCardResult.payload)
            }

            

          } else {
            reject('correct all values')
          }
        })
      })
    },
    validateStep3 () {
      return new Promise((resolve, reject) => {
          if (typeof this.$store.state.AppActiveUser.selectedPlan !== 'undefined' && this.$store.state.AppActiveUser.selectedPlan.id) {
            this.$vs.loading()

            // Create subscription
            let createSubscriptionProps = {
              customer_id: this.$store.state.AppActiveUser.stripe_id,
              plan_id: this.$store.state.AppActiveUser.selectedPlan.id,
              default_payment_method: this.$store.state.AppActiveUser.stripePaymentMethod.id
            }
            // Add coupon code if given
            if (this.couponCode) {
              createSubscriptionProps.coupon = this.couponCode
            }
            
            createStripeSubscription(createSubscriptionProps)
              .then (() => {
                //console.log('Create subscription POST result:', result);

                // Refresh the whole subs list
                getStripeSubscriptions(this.$store.state.AppActiveUser.stripe_id)  
                    .then(result => {
                        //console.log('CREATE subscription GET result:', result)
                        this.stripeSubscriptions = (result.data.data && result.data.data.length > 0) ? result.data : {};
                        this.hasSubscriptions = this.hasData(this.stripeSubscriptions)
                        this.$store.commit('UPDATE_USER_INFO', { stripeSubscriptions: this.stripeSubscriptions, hasSubscriptions: this.hasSubscriptions }, { root: true })
                        this.$vs.notify({
                          title: 'Plan subscription',
                          text: 'Subscribed to selected plan succesfully!',
                          iconPack: 'feather',
                          icon: 'icon-alert-circle',
                          color: 'success'
                        })
                        resolve(true)
                        // Redirect to home-page
                        this.$router.push('/').catch(() => {})
                    }).catch(err => {
                        const subsError = 'Error occured while fetching updated subscriptions: ' + err.response.data.raw.message
                        this.$vs.notify({
                            title: 'Plan subscription',
                            text: subsError,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        reject(subsError)
                    })
              }).catch((err) => {
                this.$vs.notify({
                  time: 10000,
                  title: 'Plan subscription',
                  text: 'Error occured while creating a subscription: ' + err.response.data.raw.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                reject('Error occured while creating a subscription: ', err.response.data.raw.message)
              }).finally(() => {
                this.$vs.loading.close()
              })

          } else {
            this.$store.commit('UPDATE_USER_INFO', { selectedPlan: {} }, { root: true })
            this.$vs.notify({
              title: 'Plan subscription',
              text: 'Please choose a plan first!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            reject('correct all values')
          }
        })
    }
  }
}
</script>
<style scoped>
.custom-label {
  margin-left: 5px;
  margin-bottom: -16px;
  font-size: 12px;
}
.country-select,
.region-select {
  display: block;
  height: 37px;
  width: 100%;
}
</style>
